var Slider = (function(){
    var self = { };
    var $slider, $slides, $sliderInner, $sliderMenu, $onOffToggle;
    var speed, total, timer;
    var direction = 'right';
    var busy = false;
    var ratio = 16 / 9;
    var i = 0;
    var running = false;


    self.init = function(options){
        options = options || { };
        speed = parseInt(options.speed, 10) || 3000;

        $slider = $('#slider');
        $sliderInner = $slider.find('.slider__inner');
        $sliderMenu = $slider.find('.options__menu');
        $onOffToggle = $slider.find('.options__toggle');

        /**
        * On récupère les informations depuis le fichier json
        */

        $.getJSON(options.feed, function(data){
            total = data.length;
            for(var k = 0; k < total; k++){
                var image = new Image();

                var $slide = $('<div>');
                $sliderInner.append($slide);
                $slide.attr('id', 'slide-'+k);
                $slide.addClass('slide');

                image.alt = data[k].alt;
                image.index = k;
                image.onload = function(){
                    $('#slide-'+this.index).append(this);
                };
                image.src = data[k].src;
            }

            $slides = $slider.find('.slide');

            // initialisation du slider
            running = true;

            optionsInit();
            self.resize();
            run();
        });

        /**
        * Évènements attachés au slider
        */

        $(window).on('resize', self.resize);

        $onOffToggle.on('click', function(e){
            e.preventDefault();
            if(running){
                self.pause();
            }
            else{
                self.resume();
            }
        });

        $('.options__controls .control').on('click', function(e){
            e.preventDefault();
            if(busy) return;

            var $this = $(this);
            var d = ($this.hasClass('control--left')) ? 'left' : 'right';

            self.pause();
            slide(d);
        });
    };

    function optionsInit(){
        for(var k = 0; k < total; k++){
            var $item = $('<li>');
            if(k == 0){
                $item.addClass('active');
            }
            $sliderMenu.append($item);
        }
    }

    /**
    * ON / OFF
    */
    self.pause = function(){
        running = false;
        $onOffToggle.find('i').removeClass('fa-pause').addClass('fa-play');
    };
    self.resume = function(){
        running = true;
        $onOffToggle.find('i').removeClass('fa-play').addClass('fa-pause');
    };


    self.resize = function(){
        var w = $slider.width();

        $slider.css({ height : ($slider.width() / ratio + $sliderMenu.height()) + 'px' });
        $sliderInner.css({ height : ($slider.width() / ratio) + 'px', left : -(w * i) + 'px' });

        $slides.each(function(j){
            $(this).css({ left : (w * j) + 'px' });
        });
    };

    /**
    * Gère le timer pour programmer la prochaine image à slider
    */
    function run(){
        clearTimeout(timer);
        timer = setTimeout(function(){
            if(!running){
                run();
            }
            else{
                slide(direction);
            }
        }, speed);
    }

    /**
    * Gère l'animation de slide
    */
    function slide(d){
        i += (d == 'right') ? 1 : -1;

        if(i < 0){
            i = 0;
            direction = 'right';
        }
        if(i >= total - 1){
            i = total - 1;
            direction = 'left';
        }

        busy = true;

        $sliderInner.animate({ left : -(i * $slider.width()) + 'px' }, 500, function(){
            $sliderMenu.find('li').removeClass('active');
            $sliderMenu.find('li:nth-child('+(i+1)+')').addClass('active');
            busy = false;
            run();
        });
    }

    return self;
})();
